// src/hooks/useCartModal.js
import { useState } from "react";
import { imagenesCursos } from "../utils/diccionarioImagenes"; 

export function useCartModal(user) {
  const [modalData, setModalData] = useState({
    isOpen: false,
    courseImage: "",
    subtotal: 0,
    type: "success"
  });

  // 🔥 NUEVO ESTADO: Controla la advertencia de inicio de sesión
  const [isAuthWarningOpen, setIsAuthWarningOpen] = useState(false);

  // const handleAddToCart = async (course) => {
  //   if (!user) {
  //     // 🔥 Abrimos el modal en lugar del alert
  //     setIsAuthWarningOpen(true);
  //     return;
  //   }

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}/cart/add.php`,
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         credentials: "include",
  //         body: JSON.stringify({
  //           user_id: user.id,
  //           course_id: course.id,
  //         }),
  //       }
  //     );

  //     const result = await response.json();
      
  //     const visual = imagenesCursos[course.id];
  //     const bgImage = visual ? visual.desktop : "https://via.placeholder.com/600x400?text=Curso+Nuevo";

  //     if (result.status === "success") {
  //       setModalData({
  //         isOpen: true,
  //         courseImage: bgImage,
  //         subtotal: course.price || 100,
  //         type: "success"
  //       });
  //     } else if (result.status === "warning") { 
  //       setModalData({
  //         isOpen: true,
  //         courseImage: bgImage,
  //         subtotal: course.price || 100,
  //         type: "already_exists"
  //       });
  //     } else {
  //       alert(result.message); // Este alert es para errores reales del servidor
  //     }
  //   } catch (err) {
  //     console.error("Error de conexión", err);
  //   }
  // };
// 🔥 1. Función exclusiva para el botón "COMPRAR" (Va a Niubiz)
  const handleBuyNow = (course) => {
    if (!user) {
      setIsAuthWarningOpen(true);
      return; 
    }

    if (course.link_niubiz) {
      window.open(course.link_niubiz, '_blank');
    } else {
      alert("El enlace de pago para este curso aún no está disponible.");
    }
  };

  // 🔥 2. Función exclusiva para el botón "ASESOR" (Va a WhatsApp)
  const handleContactAsesor = (course) => {
    const telefonoAsesor = "51958966927"; // Reemplaza con el tuyo
    const nombreCurso = course.title;
    const mensaje = `Hola, me interesa adquirir el curso: *${nombreCurso}*. ¿Me podrían dar más información?`;
    const urlWhatsapp = `https://wa.me/${telefonoAsesor}?text=${encodeURIComponent(mensaje)}`;
    
    window.open(urlWhatsapp, '_blank');
  };

  const closeModal = () => setModalData(prev => ({ ...prev, isOpen: false }));
  const closeAuthWarning = () => setIsAuthWarningOpen(false);

  // Exportamos las dos funciones nuevas
  return {
    modalData,
    isAuthWarningOpen,
    handleBuyNow,
    handleContactAsesor,
    closeModal,
    closeAuthWarning,
    setModalData
  };
}